import { CLASSIFICATION_TYPES } from './ClassificationTypes'
import { SenseApplyRateLogic } from './SenseApplyRateLogic'
import { StandardRateLogic } from './StandardRateLogic'

export class RateLogicFactory {
    getRateLogic(type) {
        switch (type) {
            case CLASSIFICATION_TYPES.JENKS:
                return new SenseApplyRateLogic()
            case CLASSIFICATION_TYPES.MEAN:
                return new StandardRateLogic()
            default:
                throw new Error(`Unknown rate logic type: ${type}`)
        }
    }
}
